import { useEffect } from 'react'

export const useFavicon = (favicon: string) => {
    const headLink = window.document.head.querySelector('link[rel="icon"]')

    useEffect(() => {
        if (favicon) {
            headLink?.setAttribute('href', favicon)
        }
    }, [headLink, favicon])
}
